export const MIN_LAUNCHER_WIDTH = 200;
export const launcherWidth = 60;
export const launcherHeight = 60;